import script from "./MetasCompartilhadas.vue?vue&type=script&setup=true&lang=js"
export * from "./MetasCompartilhadas.vue?vue&type=script&setup=true&lang=js"

import "./MetasCompartilhadas.vue?vue&type=style&index=0&id=11f13930&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11f13930"]])

export default __exports__